import { render, staticRenderFns } from "./srDiscardChangesModal.vue?vue&type=template&id=4bf15aeb&scoped=true"
import script from "./srDiscardChangesModal.vue?vue&type=script&lang=js"
export * from "./srDiscardChangesModal.vue?vue&type=script&lang=js"
import style0 from "./srDiscardChangesModal.vue?vue&type=style&index=0&id=4bf15aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf15aeb",
  null
  
)

export default component.exports